import pubsub from './pubsub';

const breathingSpace = 20; // px

export const updateScrollPaddingBottom = () => {
	const cookieDisclaimerBottomElement = document.querySelector(
		'.v2-cookie-disclaimer.v2-cookie-disclaimer--bottom'
	);
	if (!cookieDisclaimerBottomElement) return;

	const cookieDisclaimerBottomHeight = cookieDisclaimerBottomElement.getBoundingClientRect().height;
	document.documentElement.style.scrollPaddingBottom =
		cookieDisclaimerBottomHeight + breathingSpace + 'px';
	document.documentElement.style.paddingBottom = cookieDisclaimerBottomHeight + 'px';
};
export const updateScrollPaddingTop = () => {
	let paddingTop = 0;
	const navigationHeader = document.getElementById('navigation');
	if (navigationHeader) {
		paddingTop = navigationHeader.getBoundingClientRect().height;
	}

	const cookieDisclaimerTopElement = document.querySelector(
		'.v2-cookie-disclaimer.v2-cookie-disclaimer--top'
	);
	if (cookieDisclaimerTopElement) {
		paddingTop += cookieDisclaimerTopElement.getBoundingClientRect().height;
	}

	const onPageNavStickyElement = document.querySelector('.v2-onpagenav.sticky');
	if (
		onPageNavStickyElement &&
		window.getComputedStyle(onPageNavStickyElement).getPropertyValue('position') === 'fixed'
	) {
		paddingTop += onPageNavStickyElement.getBoundingClientRect().height;
	}
	document.documentElement.style.scrollPaddingTop = paddingTop + breathingSpace + 'px';
};

pubsub.subscribe('utility/updateScrollPadding', ({ isTop, isBottom }) => {
	if (isBottom) {
		updateScrollPaddingBottom();
	}
	if (isTop) {
		updateScrollPaddingTop();
	}
});
